<div class="seenBy" data-test="seenBySection">
  <div class="seenBy__title">{{ 'seen_by' | ppTranslate }}:</div>

  <div
    ppTooltip
    [ppSanitize]="false"
    [ppTitle]="seenByUsers.length > 3 ? null : tooltipText"
    [ppOptions]="{ placement: 'bottom' }"
    (mouseenter)="generateSeenBy()"
    class="seenBy__avatars"
    [class.seenBy__avatars--1]="seenByUsers.length === 1"
    [class.seenBy__avatars--2]="seenByUsers.length === 2"
    [class.seenBy__avatars--3]="seenByUsers.length > 2"
    >
    @if (seenByUsers[0]) {
      <img
        class="seenBy__avatar seenBy__first-avatar"
        [src]="users[seenByUsers[0]]?.avatarPublicUrl"
        />
    }

    @if (seenByUsers[1]) {
      <img
        class="seenBy__avatar seenBy__second-avatar"
        [src]="users[seenByUsers[1]]?.avatarPublicUrl"
        />
    }

    @if (seenByUsers[2]) {
      <img
        class="seenBy__avatar seenBy__third-avatar"
        [src]="users[seenByUsers[2]]?.avatarPublicUrl"
        />
    }

    @if (seenByUsers.length > 3) {
      <div
        class="seenBy__avatar seenBy__more"
        ppTooltip
        [ppSanitize]="false"
        [ppTitle]="tooltipText"
        [ppOptions]="{ placement: 'bottom' }"
        >
        <span class="seenBy__counter"> +{{ seenByUsers.length - 2 }} </span>
      </div>
    }
  </div>
</div>
